import axios from "axios";
import URLHelper from "../helpers/URLHelper";

const NotificationServices = {
  getNotifications: async (patient, days) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/service/intervention?patient=${URLHelper.encodeQueryParamValue(patient)}&type=notification&days=${days}`
    );
    return response;
  },
};

export default NotificationServices;
